import React from 'react';
import NextImage, { StaticImageData } from 'next/image';
import { Calendar, Walking } from '@solent-university/solent-icons';

import { LinkProps } from 'Elements/Link';

import { convertNameToId } from '../../AccommodationMap';

import {
    Wrapper,
    ThumbnailWrapperDefault,
    ThumbnailWrapperMobile,
    Inner,
    Name,
    StyledLink,
    Address,
    Excerpt,
    Details,
    Detail,
    DetailIconCalendar,
    DetailIconWalking,
    DetailText
} from './ListingCard.styled';

export interface AccommodationCardProps {
    name: string;
    residenceLink: LinkProps;
    address: string;
    excerpt: string;
    price: number;
    distance: number;
    thumbnail: {
        default: {
            src: StaticImageData | string;
            alt?: string;
        };
        mobile: {
            src: StaticImageData | string;
            alt?: string;
        };
    };
    colour: string;
}

export interface Props extends AccommodationCardProps {
    activeCard: string;
    setActiveCard: (value: string) => void;
}

const ListingCard: React.FC<Props> = props => {
    const {
        name,
        residenceLink,
        address,
        excerpt,
        price,
        distance,
        thumbnail,
        colour,
        activeCard,
        setActiveCard
    } = props;

    const id = convertNameToId(name);

    return (
        <Wrapper
            key={name}
            id={id}
            $active={id === activeCard}
            $colour={colour}
            onClick={() => setActiveCard(id)}
            data-active={id === activeCard}
        >
            <ThumbnailWrapperDefault>
                <NextImage
                    {...thumbnail.default}
                    alt={thumbnail.default.alt || ''}
                    fill
                    style={{ objectFit: 'cover' }}
                />
            </ThumbnailWrapperDefault>
            <ThumbnailWrapperMobile>
                <NextImage
                    {...thumbnail.mobile}
                    alt={thumbnail.mobile.alt || ''}
                    fill
                    style={{ objectFit: 'cover' }}
                />
            </ThumbnailWrapperMobile>
            <Inner>
                <Name>
                    <StyledLink aria-label={`View ${name} residence`} {...residenceLink}>
                        {name}
                    </StyledLink>
                </Name>
                <Address>{address}</Address>
                <Excerpt>{excerpt}</Excerpt>
                <Details>
                    <Detail>
                        <DetailIconCalendar as={Calendar} />
                        <DetailText>{price} per week</DetailText>
                    </Detail>
                    <Detail>
                        <DetailIconWalking as={Walking} />
                        <DetailText>{distance} walk</DetailText>
                    </Detail>
                </Details>
            </Inner>
        </Wrapper>
    );
};

export default ListingCard;
